import { render, staticRenderFns } from "./PendienteModal.vue?vue&type=template&id=ff627d64&"
import script from "./PendienteModal.vue?vue&type=script&lang=js&"
export * from "./PendienteModal.vue?vue&type=script&lang=js&"
import style0 from "./PendienteModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports